import countryList from "@/assets/data/countryList.json";
export interface Country {
  code: string;
  id: string;
  name: string;
  flagIcon: string;
  fallbackicon: string;
  countryCode: string;
  currency: {
    code: string;
    name: string;
    symbol: string;
  };
}

export const fetchCountries = async (): Promise<Country[]> => {
  try {
    return formatCountries(countryList);
  } catch (error) {
    console.error("Error loading country data:", error);
    return [];
  }
};

const formatCountries = (data: Array<any>): Country[] => {
  return data
    .map((country) => {
      const currencyKey = country.currencies
        ? Object.keys(country.currencies)[0]
        : null;

      if (!currencyKey) return null;

      const currencyData = country.currencies[currencyKey];

      return {
        code: country.cca2,
        id: country.cca2,
        name: country.name?.common || "",
        flagIcon: country.flags.svg,
        fallbackicon: country.flags.png,
        countryCode: country.idd?.root
          ? country.idd.root +
            (country.idd.suffixes ? country.idd.suffixes.join("") : "")
          : "",
        currency: {
          code: currencyKey,
          name: currencyData.name,
          symbol: currencyData.symbol || "",
        },
      };
    })
    .filter((c): c is Country => c !== null);
};

export const filterCountriesByCurrency = (
  countries: Country[],
  allowedCurrencyCodes: string[],
): Country[] => {
  const upperCaseCodes = allowedCurrencyCodes.map((c) => c.toUpperCase());

  return countries.filter((country) =>
    upperCaseCodes.includes(country.currency.code.toUpperCase()),
  );
};

export const clearCountriesCache = (): void => {
  // Cache is no longer used, but keeping for API compatibility
};
